import { render, staticRenderFns } from "./MfrTable.vue?vue&type=template&id=486bb444&"
import script from "./MfrTable.vue?vue&type=script&lang=ts&"
export * from "./MfrTable.vue?vue&type=script&lang=ts&"
import style0 from "./MfrTable.vue?vue&type=style&index=0&id=486bb444&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports